import type { I18nStrings } from './types'

export const zh: I18nStrings = {
  brand: 'ResearchFlow Forge',
  nav: {
    home: '首页',
    skills: '技能',
    workflows: '工作流',
    gallery: '图集',
    guide: '指南',
    language: 'EN / 中文',
  },
  home: {
    badge: '学术工具台 V0 已上线',
    title: '一座锻造台，\n驾驭全部科研技能。',
    subtitle:
      '为学术研究者与技术架构师打造的精致指挥中心。精选科研技能、组合复杂工作流、生成精确的自动化安装命令。',
    browseSkills: '浏览技能目录',
    exploreWorkflows: '探索工作流',
    stats: {
      repos: '参考仓库',
      skills: '技能',
      workflows: '工作流',
    },
    features: {
      title: '精密工具',
      subtitle: '构建与部署学术 Agent 所需的一切。',
      catalog: {
        title: '技能目录',
        desc: '精选的 agent skills，从数据综合到文献解析，满足严谨学术标准。',
      },
      workflow: {
        title: '工作流模板',
        desc: '面向常见科研方法的预配置架构模式。',
      },
      builder: {
        title: '安装命令构建器',
        desc: '根据你的环境与技能选择，生成精确、安全的 CLI 命令。',
      },
      gallery: {
        title: '可视化图集',
        desc: '探索社区工作流生成的高保真图表与数据可视化样例。',
      },
    },
  },
  catalog: {
    title: '技能目录',
    subtitle: '发现并将专业的学术与科学技能集成到你的本地锻造环境中。',
    searchPlaceholder: '搜索技能、包或作者...',
    categories: {
      workflow: '工作流与流程',
      writing: '写作与润色',
      research: '研究与科学',
      figures: '图表与可视化',
      compute: '计算与环境',
    },
    sourceRepo: '来源仓库',
    addToCommand: '加入命令',
    added: '已添加',
    noResults: '没有匹配的技能。',
  },
  workflows: {
    title: '科研任务',
    subtitle:
      '选择预配置的工作流模板，快速实例化复杂的科研自动化流程。每个任务将多个学术技能组合成连贯的流水线。',
    estSteps: '预计步骤',
    recommendedSkills: '推荐技能',
    selectWorkflow: '选择工作流',
    selected: '已选择',
    details: '详情',
    complexity: {
      low: '低复杂度',
      medium: '中等复杂度',
      high: '高复杂度',
    },
  },
  workflowDetail: {
    advancedWorkflow: '高级工作流',
    highComplexity: '高复杂度',
    instantiate: '实例化工作流',
    saveToLibrary: '保存到库',
    executionPathway: '执行路径',
    requiredSkills: '所需技能',
    expectedOutputs: '预期产出',
    limitations: '限制与归属',
  },
  gallery: {
    title: '科学可视化',
    subtitle:
      '探索由 ResearchFlow Forge skills 生成的高保真示意图、多面板 Nature 风格图表与复杂 AI 流程图精选集。',
    copyPrompt: '复制提示词',
    copied: '已复制',
    skill: '技能',
    mockNote: '作品集演示用模拟可视化。',
  },
  installer: {
    title: 'Forge 安装器',
    subtitle: '构建你的自动化',
    commandBuilder: '命令构建器',
    selectedItems: '已选项',
    platformSelector: '平台选择',
    targetPlatform: '目标平台',
    targetTool: '目标工具',
    macLinux: 'macOS / Linux',
    windowsWsl: 'Windows (WSL)',
    generatedCommand: '生成命令',
    copyRun: '复制并运行',
    advanced: '高级',
    documentation: '文档',
    github: 'GitHub',
    emptyState: '从画布选择一个科研任务或技能，开始锻造你的自动化流水线。',
    selectedSkills: '已选技能',
    selectedWorkflow: '已选工作流',
    mockDisclaimer:
      'V0 使用模拟命令。第三方仓库均已标注来源。本站不是官方镜像。',
    copied: '已复制',
  },
  footer: {
    copyright: '© 2024 ResearchFlow Forge. AcademicForge 与 Scientific Agent Skills。',
    documentation: '文档',
    githubRepo: 'GitHub 仓库',
    attribution: '来源归属',
    privacy: '隐私',
  },
  common: {
    en: 'EN',
    zh: '中文',
  },
}
